import { AnyAction } from 'redux';
import { Next } from '../../types/redux';

export default () => (next: Next) => (action: AnyAction) => {
  window.__ELIS_DEVTOOLS_ON_DISPATCH__?.(action);
  return next(action);
};
